import { useBehavior, useCheckBox } from '@libs/hooks';
import { TInputData, TWidget } from '@libs/types';
import { type TCoreCheckboxOptions, type TCoreInputData } from '@core/widgets';
import React from 'react';
import { TCheckboxOption } from '../../types/options';
import { SwitcherView } from './SwitcherView';

type TSwitcherProps<TD, TO> =
    | {
          isWidget: true;
          widget: TWidget<TD, TO>;
      }
    | ({
          isWidget: false;
          uid?: string;
          value: boolean;
          handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
      } & Pick<TInputData, 'tabIndex' | 'messages' | 'label'> &
          TCheckboxOption);

const Switcher = (props: TSwitcherProps<TInputData, TCheckboxOption>) => {
    const { isWidget } = props;
    const finalWidget = !isWidget
        ? ({
              uid: props.uid ?? '',
              data: {
                  value: props.value,
                  tabIndex: props.tabIndex,
                  label: props.label,
                  messages: props.messages,
              },
              options: {
                  isDisabled: props.isDisabled,
                  margin: props.margin,
                  autofill: props.autofill,
              },
          } as TWidget<TInputData, TCheckboxOption>)
        : props.widget;

    const data = finalWidget.data ?? {};
    const options = finalWidget.options ?? {};
    const label = data.messages?.label || data.label;

    const { isChecked: checkBoxIsChecked, handleChange: checkBoxHandleChange } = useCheckBox(finalWidget, { skipValidation: true });
    const { isDisabled, isHidden } = useBehavior(finalWidget);

    const isChecked = isWidget ? checkBoxIsChecked : props.value;
    const handleChange = isWidget ? checkBoxHandleChange : props.handleChange;

    const parentStyleNames = [finalWidget.options?.style].filter(Boolean) as string[];

    return (
        <SwitcherView
            uid={finalWidget.uid}
            widget={finalWidget as TWidget<TCoreInputData, TCoreCheckboxOptions>}
            label={label}
            isChecked={isChecked}
            handleChange={handleChange}
            isDisabled={isDisabled}
            isHide={isHidden}
            margin={options.margin}
            style={finalWidget.options?.style}
            parentStyleNames={parentStyleNames}
        />
    );
};
export { Switcher };
